import { useState, useEffect } from 'react';

const useContextMenu = () => {
  const [open, setOpen] = useState(false);
  const [points, setPoints] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const handleClick = () => setOpen(false);
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  // Not sure if we need anymore in react18 world - commenting for now (josh)
  // useEffect(() => {
  //   const handleClick = () => {
  //     if (open) setOpen(false);
  //   };
  //   document.addEventListener('contextmenu', handleClick);
  //   return () => {
  //     document.removeEventListener('contextmenu', handleClick);
  //   };
  // }, [open]);

  return {
    open,
    setOpen,
    points,
    setPoints,
  };
};

export default useContextMenu;
